import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Linkedin } from "lucide-react";

const LINK_CLS = "block text-sm text-cream/60 hover:text-cream transition-colors";

export function SiteFooter() {
  return (
    <footer className="bg-espresso text-cream">
      <div className="max-w-6xl mx-auto px-6 pt-16 pb-10">
        <p className="font-serif font-light text-5xl sm:text-6xl tracking-tight text-cream/90">PaySignal</p>
        <div className="mt-10 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="text-sm text-cream/60 max-w-xs leading-relaxed">A lightweight invoice &amp; payout tracker for independent workers. Not an accounting or debt-collection service.</p>
            <div className="flex gap-3 mt-5">
              <a href="https://www.facebook.com/PaySignal" target="_blank" rel="noopener noreferrer" aria-label="PaySignal on Facebook" data-testid="social-facebook"
                className="grid place-items-center w-9 h-9 rounded-lg border border-cream/20 text-cream/70 hover:text-cream hover:border-cream/50 transition-colors">
                <Facebook size={17} />
              </a>
              <a href="https://www.linkedin.com/company/paysignalledger/" target="_blank" rel="noopener noreferrer" aria-label="PaySignal on LinkedIn" data-testid="social-linkedin"
                className="grid place-items-center w-9 h-9 rounded-lg border border-cream/20 text-cream/70 hover:text-cream hover:border-cream/50 transition-colors">
                <Linkedin size={17} />
              </a>
            </div>
          </div>
          <div className="space-y-2.5">
            <p className="font-semibold text-cream text-sm">Legal</p>
            <Link to="/terms" className={LINK_CLS} data-testid="footer-terms">Terms of Service</Link>
            <Link to="/privacy" className={LINK_CLS} data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/sms-terms" className={LINK_CLS} data-testid="footer-sms-terms">SMS Terms</Link>
          </div>
          <div className="space-y-2.5">
            <p className="font-semibold text-cream text-sm">Product</p>
            <Link to="/how-it-works" className={LINK_CLS} data-testid="footer-how">How it works</Link>
            <Link to="/pricing" className={LINK_CLS} data-testid="footer-pricing">Pricing</Link>
            <Link to="/integrations" className={LINK_CLS} data-testid="footer-integrations">Integrations</Link>
            <Link to="/signup" className={LINK_CLS} data-testid="footer-get-started">Get started</Link>
            <Link to="/login" className={LINK_CLS} data-testid="footer-login">Log in</Link>
          </div>
          <div className="space-y-2.5">
            <p className="font-semibold text-cream text-sm">Company</p>
            <Link to="/about" className={LINK_CLS} data-testid="footer-about">About</Link>
            <Link to="/contact" className={LINK_CLS} data-testid="footer-contact">Contact Us</Link>
            <Link to="/blog" className={LINK_CLS} data-testid="footer-blog">Blog</Link>
          </div>
        </div>
        <div className="border-t border-cream/15 mt-12 pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-cream/50">
          <p>© 2026 PaySignal. Built for independent workers. Message &amp; data rates may apply to SMS. Reply STOP to cancel, HELP for help.</p>
          <p className="sm:text-right" data-testid="footer-company">
            PaySignal.AI is created &amp; managed by<br className="hidden sm:block" />
            <span className="text-cream/70 font-medium">Retention Logix LLC</span> · 151 Calle San Francisco, San Juan, PR 00901
          </p>
        </div>
      </div>
    </footer>
  );
}
